import { render, staticRenderFns } from "./MoleculeSendRequest.vue?vue&type=template&id=2d10bc64&"
import script from "./MoleculeSendRequest.vue?vue&type=script&lang=js&"
export * from "./MoleculeSendRequest.vue?vue&type=script&lang=js&"
import style0 from "./MoleculeSendRequest.vue?vue&type=style&index=0&id=2d10bc64&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/lang/MoleculeSendRequest.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fcomponents%2Fmolecules%2Fproject%2FMoleculeSendRequest.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCommonAtomIcon: require('/app/components/atoms/common/AtomIcon.vue').default})
